import { ProductInstruction } from './ProductInstruction'

export function WbDtuHelp({ completed, productKind, instructions }) {
  if (productKind && productKind !== 'steam_wallet') return <>
    {!completed && <ProductInstruction title='Как получить пополнение' hint='Проверьте данные получателя перед подтверждением.'><p style={{ whiteSpace: 'pre-line' }}>{instructions}</p></ProductInstruction>}
    <section className='order-help' aria-label='Помощь с пополнением'><h2>Часто задаваемые вопросы</h2><details className='wb-dtu-faq'><summary>Как проверить результат пополнения?</summary><p>{productKind === 'mobile' ? 'Проверьте баланс или подключение пакета в приложении вашего мобильного оператора.' : 'Проверьте баланс Lattice в игре Marvel Rivals.'} Если нужна помощь, напишите продавцу в чате заказа Wildberries. Не сообщайте пароль или код из SMS.</p></details></section>
  </>
  return <>
    {!completed && <ProductInstruction title='Как пополнить Steam' hint='Откройте инструкцию перед пополнением кошелька Steam.'>
      <ol>
        <li>Введите логин, который используете для входа в Steam. Пароль не нужен.</li>
        <li>Проверьте логин и соответствие региона и валюты аккаунта купленному товару.</li>
        <li>Подтвердите данные и нажмите «Пополнить аккаунт».</li>
        <li>Дождитесь результата на этой странице. Статус обновляется автоматически.</li>
      </ol>
    </ProductInstruction>}
    <section className='order-help' aria-label='Помощь с пополнением Steam'>
      <h2>Часто задаваемые вопросы</h2>
      {!completed && <details className='wb-dtu-faq'>
        <summary>Где найти мой логин в Steam?</summary>
        <p>В Steam откройте меню аккаунта в правом верхнем углу и выберите «Об аккаунте». Используйте имя аккаунта для входа. Отображаемое имя игрока и ссылка на профиль не подходят.</p>
      </details>}
      <details className='wb-dtu-faq'>
        <summary>{completed ? 'Пополнение не поступило на мой аккаунт?' : 'Как проверить результат пополнения?'}</summary>
        <p>Проверьте баланс кошелька и историю покупок в своём аккаунте Steam. Если нужна помощь, напишите продавцу в чате этого заказа на Wildberries. Укажите номер заказа; пароль сообщать не нужно.</p>
      </details>
    </section>
  </>
}
